var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.98 17.966c.178.035.516.126.704.126 1.617 0 2.928-1.331 2.928-2.974 0-1.642-1.311-2.974-2.928-2.974l-.198.005m-14.732 0C3.218 12.242 2 13.535 2 15.12c0 1.642 1.31 2.973 2.928 2.973h.467m-.641-5.942L2 4.801l5.112.95L10.387 1l4.75 3.4 4.368-2.596-.019 10.345m-14.732 0c0 1.096.14 3.336.14 3.336.202 4.187 3.393 7.015 7.3 7.015 4.038 0 7.287-3.054 7.287-7.437l.005-2.914m-14.732 0L19.49 9.637"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUudIcon);
export default __webpack_public_path__ + "static/media/uud_icon.1d79eccee26c54e5fa72480a38e64d36.svg";
export { ForwardRef as ReactComponent };